import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export const Manifesto = () => {
  const { t } = useLanguage();

  return (
    <section
      id="manifesto"
      className="relative border-b bp-border"
      data-testid="manifesto-section"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="border-b bp-border py-6">
          <p className="font-mono-x text-[10px] uppercase tracking-[0.3em] text-muted-x">
            // {t.manifesto.subtitle}
          </p>
          <h2 className="mt-2 font-display text-3xl uppercase tracking-tight sm:text-4xl lg:text-5xl">
            {t.manifesto.title}
          </h2>
        </div>

        <div>
          {t.manifesto.items.map((item, i) => (
            <motion.div
              key={item.no}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="group relative grid grid-cols-1 items-start gap-4 border-b bp-border py-10 transition-colors duration-500 hover:bg-[var(--xp-primary)] md:grid-cols-12 md:gap-8"
              data-testid={`manifesto-item-${item.no}`}
            >
              <div className="col-span-1 flex items-center gap-4 md:col-span-3">
                <span className="font-display text-5xl leading-none tracking-tighter text-outline transition-all duration-500 group-hover:text-white group-hover:[-webkit-text-stroke:0]">
                  {item.no}
                </span>
                <ArrowUpRight className="h-5 w-5 opacity-40 transition-all duration-500 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-white group-hover:opacity-100" />
              </div>
              <h3 className="col-span-1 font-display text-2xl uppercase tracking-tight transition-colors duration-500 group-hover:text-white md:col-span-4 md:text-3xl">
                {item.title}
              </h3>
              <p className="col-span-1 max-w-xl text-sm leading-relaxed text-muted-x transition-colors duration-500 group-hover:text-white/90 md:col-span-5">
                {item.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
